// generated by scripts/build-palettes.js (npm run theme:palettes), do not edit
export default [
    {
        "id": "default",
        "light": "#006fb5",
        "dark": "#3699ff"
    },
    {
        "id": "violet",
        "light": "#8138ff",
        "dark": "#ad7dff"
    },
    {
        "id": "indigo",
        "light": "#5050ff",
        "dark": "#8a8aff"
    },
    {
        "id": "cyan",
        "light": "#007684",
        "dark": "#00a6b9"
    },
    {
        "id": "teal",
        "light": "#007965",
        "dark": "#00aa8e"
    },
    {
        "id": "green",
        "light": "#007c42",
        "dark": "#00ad5c"
    },
    {
        "id": "lime",
        "light": "#4b7700",
        "dark": "#6aa700"
    },
    {
        "id": "gold",
        "light": "#8a6500",
        "dark": "#c28e00"
    },
    {
        "id": "orange",
        "light": "#b64900",
        "dark": "#ff6600"
    },
    {
        "id": "crimson",
        "light": "#d8001d",
        "dark": "#ff5f75"
    },
    {
        "id": "rose",
        "light": "#d40055",
        "dark": "#ff599b"
    }
];

// the original blue colours of the styles (r, g, b), in the order of the variables --pcl-N / --pcd-N
export const CUSTOM_COLORS: {light: number[][]; dark: number[][]} = {"light":[[0,111,181],[234,244,251],[227,243,253],[238,243,247],[241,250,255],[245,248,250],[0,90,148],[0,158,246],[0,64,105],[204,226,240],[194,215,228],[189,209,222],[179,212,233],[0,94,154],[0,89,145],[38,133,192],[0,83,136],[252,253,254],[0,67,109],[0,54,87],[247,249,251],[210,239,255],[59,89,152],[48,73,124],[29,161,242],[13,141,220],[0,119,181],[0,94,143],[0,17,28],[0,178,255],[0,152,218],[0,163,255],[19,38,60],[44,63,91]],"dark":[[0,111,181],[90,180,236],[29,50,72],[24,48,73],[54,153,255],[33,46,72],[24,125,228],[0,158,246],[0,115,233],[215,235,255],[194,212,230],[204,223,242],[199,217,236],[195,224,255],[84,168,255],[74,163,255],[46,130,217],[94,173,255],[22,61,102],[175,214,255],[18,49,82],[32,92,153],[28,50,56],[23,33,51],[18,32,36],[59,89,152],[48,73,124],[29,161,242],[13,141,220],[0,119,181],[0,94,143],[0,77,156],[0,178,255],[0,152,218],[245,248,250],[0,163,255],[19,38,60],[44,63,91]]};
